module.exports = __webpack_public_path__ + "media/images/share-reports-aa33a1cd884e81439dc2008e67f2a1e2.jpg";